import { SectionService } from "../../../section/core/section.service";
import { Section } from "../../../store/model/section.model";
import { FormButtonType, FormConfig, FormField } from "./form-config-abstract";

export class FormConfigEditSection extends FormConfig<Section>{
    constructor(private sectionService : SectionService){ super(); }

    apiService = () => this.sectionService;

    buttons : FormButtonType[] = ["CANCEL", "CREATE"];

    fields: Array<FormField<Section> | FormField<Section>[]> = [
        {
            name : "name",
            label : "section.edit.title",
            required : true,
            type : 'text'
        },
        {
            name : "description",
            label : "section.edit.description",
            type : 'text'
        },
        {
            name : ["start", "end", "publishSectionVisible"],
            labelPre : "section.edit",
            type : "visibleDateRange",
            controlName : "fromToDates"
        }
    ];
}
